var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1213 -919)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(553 98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(143 807)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(507 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m18 29v4.304c0 0.30067 0.20457 0.567 0.5075 0.66166 0.075732 0.0232 0.15343 0.034336 0.23015 0.034336 0.23014 0 0.45242-0.10208 0.59405-0.28396l2.6683-3.4261-4-1.2899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.698 12.132c-0.22042-0.15485-0.50983-0.17575-0.74941-0.0513l-21.562 11.162c-0.25492 0.13205-0.40537 0.40185-0.38429 0.6859 0.022042 0.285 0.21275 0.5282 0.48396 0.62035l5.9944 2.0311 12.766-10.82-9.8785 11.798 10.046 3.4038c0.07475 0.0247 0.15333 0.038 0.23192 0.038 0.13033 0 0.25971-0.03515 0.37375-0.10355 0.18208-0.1102 0.30571-0.29545 0.33733-0.5035l2.6354-17.575c0.039292-0.266-0.073792-0.5301-0.29421-0.6859z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.0d7f9f5db4f333bdf94d1a1264295c81.svg";
export { ForwardRef as ReactComponent };